import { changeVariant } from '../slice/product.slice';

export const variantUpdatedEvent = changeVariant;
